import { useEffect, useRef, useState } from "react";

export const FloatingSave = ({ content, savedVersion, saveContent, savingContent }) => {
  const savedRef = useRef(null);
  const versionRef = useRef(savedVersion);
  const [dirty, setDirty] = useState(false);
  useEffect(() => {
    const json = JSON.stringify(content);
    if (savedRef.current === null || versionRef.current !== savedVersion) savedRef.current = json;
    versionRef.current = savedVersion;
    setDirty(json !== savedRef.current);
  }, [content, savedVersion]);
  return (
    <div
      data-testid="content-save-floating"
      data-dirty={dirty ? "true" : "false"}
      className={`fixed bottom-5 left-1/2 -translate-x-1/2 z-[70] flex items-center gap-3 rounded-full border shadow-2xl px-5 py-3 transition-colors ${dirty ? "border-accent/30 bg-[#1A2E26] text-white" : "border-border bg-white/90 backdrop-blur text-foreground"}`}
    >
      <span data-testid="content-save-floating-status" className={`text-xs hidden sm:inline ${dirty ? "text-white/80" : "text-muted-foreground"}`}>
        {dirty ? "You have unsaved changes" : "All changes saved"}
      </span>
      {dirty && <span className="w-2 h-2 rounded-full bg-accent animate-pulse hidden sm:inline-block" />}
      <button
        data-testid="content-save-floating-btn"
        onClick={saveContent}
        disabled={savingContent}
        className={`rounded-full px-5 py-1.5 text-xs font-medium transition-opacity disabled:opacity-60 ${dirty ? "bg-accent text-white hover:opacity-90" : "bg-[#1A2E26] text-white hover:opacity-90"}`}
      >
        {savingContent ? "Saving…" : "Save content"}
      </button>
    </div>
  );
};
